/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Compare_Event_GroupsInputs */

const en_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Event Groups`)
};

const fr_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer les groupes d'événements`)
};

const de_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppen vergleichen`)
};

const it_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta gruppi di eventi`)
};

const ru_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнение групп событий`)
};

const es_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar grupos de eventos`)
};

const zh_cn2_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较事件组`)
};

const ja_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを比較する`)
};

const hi_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूहों की तुलना करें`)
};

const pt_pt2_event_group_options_compare_event_groups = /** @type {(inputs: Event_Group_Options_Compare_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Compare Event Groups" |
*
* @param {Event_Group_Options_Compare_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_compare_event_groups = /** @type {((inputs?: Event_Group_Options_Compare_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Compare_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_compare_event_groups(inputs)
	if (locale === "de") return de_event_group_options_compare_event_groups(inputs)
	if (locale === "it") return it_event_group_options_compare_event_groups(inputs)
	if (locale === "ru") return ru_event_group_options_compare_event_groups(inputs)
	if (locale === "es") return es_event_group_options_compare_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_compare_event_groups(inputs)
	if (locale === "ja") return ja_event_group_options_compare_event_groups(inputs)
	if (locale === "hi") return hi_event_group_options_compare_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_compare_event_groups(inputs)
	return en_event_group_options_compare_event_groups(inputs)
});